import { useGetAuthInspectQuery, useGetProfilesQuery } from '../store/backendApi';

/**
 * Shared hook for authentication state and user profile data.
 * Provides consistent access to auth inspection and profile information
 * across the application.
 *
 * The hook first checks session state via /auth/inspect, then only fetches
 * the full profile if a session exists. This avoids unnecessary 401 errors
 * on public pages while maintaining security enforcement at the backend.
 *
 * @returns Authentication state and profile data
 */
export function useAuthenticatedUser() {
  const { data: inspectData } = useGetAuthInspectQuery();
  const { data: profile } = useGetProfilesQuery(undefined, {
    skip: !inspectData,
  });

  return {
    inspectData,
    profile,
    isAuthenticated: !!profile,
    isLoggedIn: !!profile?.userId,
  };
}
